export default __webpack_public_path__ + "upload/1.d3e0a76b.png";